import Vue from "vue";
import axios from "axios";
import "element-ui/lib/theme-chalk/index.css";
import ElementUI from "element-ui";
import Clipboard from "vue-clipboard2";
import componentsRegister from "@/components";
import "@/style/index.css";
import router from "@/router";
import store from "@/store";
import App from "./App.vue";


Vue.prototype.$axios = axios;

Vue.use(ElementUI)
  .use(componentsRegister)
  .use(Clipboard);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
